import { MARK_NOTIFICATIONS_READ } from '../../constants/api'
import errorHandler from './errorHandler'

export default (ids: string[], token: string) =>
  fetch(MARK_NOTIFICATIONS_READ, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ids }),
  }).then(errorHandler)
